import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

import LinkIcon from "../../assets/Link.png"

const UnlinkPluxeeModal = ({ open, onClose, onConfirm }) => {
  return (
    <Modal open={open} onClose={(e)=>{onClose(false)}}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 320,
          bgcolor: "white",
          boxShadow: 24,
          borderRadius: "12px",
          p: 3,
          textAlign: "center",
          zIndex:99999999999999999999999999999
        }}
      >
        {/* Image */}
        <div style={{display:"flex",justifyContent: "center"}}>
        <img
          src={LinkIcon}
          style={{
            marginTop: "-60px",
            width: "95px",
          }}
          alt=""
        />
        </div>

        {/* Title */}
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            color: "#384F6F",
            letterSpacing: "1px",
            mt: -1,
          }}
        >
          Unlink Pluxee
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            fontSize: "13px",
            mt: 1,
            color: "rgba(56, 79, 111, 0.69)",
            lineHeight: "18px",
          }}
        >
          Are you sure you want to unlink your Pluxee Wallet?
        </Typography>

        {/* Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            mt: 3,
          }}
        >
          {/* No button */}
          <Button
            onClick={(e)=>{onClose(false)}}
            sx={{
              width: "120px",
              height: "40px",
              fontWeight: "800",
              letterSpacing: "1px",
              backgroundColor: "#6c757d",
              color: "#fff",
              "&:hover": { backgroundColor: "#5a6268" },
            }}
          >
            No
          </Button>

          {/* Yes Button */}
          <Button
            onClick={onConfirm}
            sx={{
              width: "120px",
              height: "40px",
              fontWeight: "800",
              letterSpacing: "1px",
              backgroundColor: "#d9534f",
              color: "#fff",
              "&:hover": { backgroundColor: "#c9302c" },
            }}
          >
            Yes
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UnlinkPluxeeModal;
